import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import Recommendations  from "../components/Recommendations";


const UsersListPage = () => {
  return (
    <>

      {/* MasterLayout */}

        {/* Breadcrumb */}
        <Breadcrumb title="Recommendation" />

        {/* UsersListLayer */}
        <Recommendations />


    </>
  );
};

export default UsersListPage; 
